const routers = [
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: 'home' */ 'views/home/index.vue'),
    meta: {
      title: '发票开具'
    }
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import(/* webpackChunkName: 'detail' */ 'views/detail/index.vue'),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/already',
    name: 'already',
    component: () => import(/* webpackChunkName: 'already' */ 'views/already/index.vue'),
    meta: {
      title: '发票开具'
    }
  },
  {
    path: '/success',
    name: 'success',
    component: () => import(/* webpackChunkName: 'success' */ 'views/success/index.vue'),
    meta: {
      title: '开票成功'
    }
  },
  {
    path: '/',
    redirect: '/home'
  }
]

export default routers
